import './ProgressBar.scss'

function ProgressBar({ percent }) {
  return (
    <span className='progress-bar-container'>
      <span
        className='progress-bar-fill'
        style={{ width: `${percent}%` }}
      ></span>
    </span>
  )
}

export default ProgressBar
